import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export enum TabAction {
  JOIN = 'join',
  WATCH = 'watch'
}

@Component({
  selector: 'app-tab-room',
  templateUrl: './tab-room.component.html',
  styleUrls: ['./tab-room.component.scss']
})
export class TabRoomComponent implements OnInit {

  @Input()
  actions?: string[];

  @Input()
  tab;

  @Output()
  joinAction: EventEmitter<void> = new EventEmitter();

  @Output()
  watchAction: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  displayAction(action: TabAction): boolean {
    return !this.actions || (this.actions && this.actions.includes(action));
  }

  join() {
    this.joinAction.emit();
  }

  watch() {
    this.watchAction.emit();
  }

  roomStatusMessage(tab) {
    return this.isRoomFull(tab) ? 'Room is full' : 'Looking for players';
  }

  isRoomOpacity(tab): boolean {
    return this.isRoomFull(tab) && tab.tabKey === 'playNow'
  }

  isRoomFull(tab): boolean {
    return tab.players.length === tab.nbPlayers;
  }

  get players() {
    return this.tab.players.filter(player => player.roles.includes('player'));
  }

}